import React from 'react';
import s from './styles.module.css'
import Wrapper from '../../components/wrapper';
import HeaderTitle from '../../components/header_title';

const Contact = () => {
  let success = new URL(document.location.href).searchParams.get('success');
  return (
    <div className={s.contact}>
      <Wrapper>
        <HeaderTitle/>
        {success === 'true' ? <p className={s.success}>Su formulario ha sido enviado.</p> :
          <form method="post" encType="text/plain" action="/api/credits/sendFeedback">
            <p className={s.text}>
              <div><b>Nombre</b></div>
              <div><input type="text" required name="name"/></div>
            </p>
            <p className={s.text}>
              <div><b>Correo electrónico</b></div>
              <div><input type="email" required name="email"/></div>
            </p>
            <p className={s.text}>
              <div><b>Su mensaje</b></div>
              <div><textarea required name="text" cols="30" rows="10"/></div>
            </p>
            <button type="submit">Siguiente</button>
          </form>
        }
      </Wrapper>
    </div>
  );
};

export default Contact;
